export const ABOUT_US = "/about-us";
export const NEWSLETTER = "/newsletter";
export const BLOG = "/blog";
export const POST_FILE_UPLOAD = "/internal/posts/file-upload";
export const BLOG_ITEM = "/blog/[slug]";
export const CAPABILITIES = "/capabilities";
export const CHARACTER_LABELER =
  "/internal/nsf-phase-i-tools/character-labeler";
export const COMPONENTS = "/components";
export const CUSTOM_PARTS = "/internal/parts/custom-parts";
export const CONTACT = "/contact";
export const CUSTOMER_BOARDS = "/internal/boards";
export const CUSTOMER_MESSAGES = "/internal/messages";
export const CUSTOMER_ORDERS = "/internal/orders";
export const DOCS = "/docs";
export const DOCS_ITEM = "/docs/[slug]";
export const EDIT_POST = "/internal/posts";
export const FEEDER_REPORT = "/internal/feeder-report";
export const API_DOCS = "/internal/api-docs";
export const REPORT_A_BUG = "/internal/report-a-bug";
export const FIXED_WIDTH_CONVERTER = "/internal/fixed-width-converter";
export const FORGOT_PASSWORD = "/forgot-password";
export const HOMEPAGE = "/";
export const INVENTORY_BINS = "/internal/inventory/bins";
export const INVENTORY_UPDATES = "/internal/inventory";
export const STENCIL_INVENTORY = "/internal/inventory/stencils";
export const PANEL_INVENTORY = "/internal/inventory/panels";
export const MY_ACCOUNT = "/my-account";
export const MANUFACTURING_DASHBOARD = "internal/manufacturing-dashboard";
export const PARTS_DASHBOARD = "internal/parts-dashboard";
export const ORDER_COMPLETE = "/order-complete/[orderId]";
export const PRESS = "/press";
export const PRESS_ITEM = "/press/[slug]";
export const PRESS_NSF_PHASE_I = "/press/nsf-phase-i";
export const PRICING = "/internal/pricing";
export const PRIVACY = "/privacy";
export const REVIEW_BOARD = "/review-board/[boardId]";
export const SHOPPING_CART = "/shopping-cart";
export const UPLOAD_BOARD = "/upload-board";
export const USERS = "/internal/users";
export const SITE_CONFIG = "/internal/config";
export const AUTH_CREDENTIALS = "/internal/auth-credentials";
export const INTERNAL_SIGNIN = "/internal";
